import {Action, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {VibrationDiagnostic} from '@/views/services/vibrationDiagnostic/interfaces';
import {EntityDBModule} from '../entities/entityDBStorageModule';

/*
    Динамический модуль хранилища vuex для журнала Помощь в диагностике
*/

const moduleName = 'vibrationDiagnosticModule';

function transformGet(elem: any): VibrationDiagnostic {
  return {
    id: elem.id,
    name: elem.name,
    accelerometerId: elem.accelerometerId,
    tahoId: elem.tahoId,
    comparedDiagrams: elem.comparedDiagrams,
    detachedSignalDiagrams: elem.detachedSignalDiagrams,
    spectrumDiagrams: elem.spectrumDiagrams,
    currentDateTimeInterval: elem.currentDateTimeInterval,
    diagramsToCompare: elem.diagramsToCompare,
    showAngleDiagram: elem.showAngleDiagram,
  };
}

function transformCreateEdit(elem: any): VibrationDiagnostic {
  return {
    name: elem.name,
    accelerometerId: elem.accelerometerId,
    tahoId: elem.tahoId,
    comparedDiagrams: elem.comparedDiagrams,
    detachedSignalDiagrams: elem.detachedSignalDiagrams,
    spectrumDiagrams: elem.spectrumDiagrams,
    currentDateTimeInterval: elem.currentDateTimeInterval,
    diagramsToCompare: elem.diagramsToCompare,
    showAngleDiagram: elem.showAngleDiagram,
  };
}

function transformSave(model: VibrationDiagnostic): any {
  return {
    id: model.id,
    name: model.name,
    accelerometerId: model.accelerometerId,
    tahoId: model.tahoId,
    comparedDiagrams: model.comparedDiagrams,
    detachedSignalDiagrams: model.detachedSignalDiagrams,
    spectrumDiagrams: model.spectrumDiagrams,
    currentDateTimeInterval: model.currentDateTimeInterval,
    diagramsToCompare: model.diagramsToCompare,
    showAngleDiagram: model.showAngleDiagram,
  };
}

function getCreate(): VibrationDiagnostic {
  return {
    name: '',
    comparedDiagrams: [],
    detachedSignalDiagrams: [],
    spectrumDiagrams: [],
    diagramsToCompare: [],
  };
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class VibrationDiagnosticModule extends EntityDBModule {
  protected etitieName = 'vibration_diagnostic_settings';
  protected routeName = '/profile';

  get all(): VibrationDiagnostic[] {
    const full_list: VibrationDiagnostic[] = (super.all as VibrationDiagnostic[]).slice();
    return full_list.sort((a, b) => a.name.localeCompare(b.name));
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    return super.fetchAll(transformGet);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: VibrationDiagnostic}> {
    return super.create(getCreate, transformCreateEdit) as Promise<{data: VibrationDiagnostic}>;
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: VibrationDiagnostic}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: VibrationDiagnostic}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: VibrationDiagnostic) {
    return super.save(model, transformSave);
  }
}

export default getModule(VibrationDiagnosticModule);
